export enum NotificationType {
    Info,
    Warn,
    Error
}